import { render } from "./Crown.vue?vue&type=template&id=654e9ac6&scoped=true"
import script from "./Crown.vue?vue&type=script&lang=js"
export * from "./Crown.vue?vue&type=script&lang=js"

import "./Crown.vue?vue&type=style&index=0&id=654e9ac6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654e9ac6"]])

export default __exports__